import LayerSelection from './layers/LayerSelection.tsx';

export const LayersPanel = () => {
  return <LayerSelection />;
};

export default LayersPanel;
